(function () {
  var root = document.querySelector('[id^="ps-"][data-home]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var lang = 'fr';
  try { lang = localStorage.getItem('ps-lang') || 'fr'; } catch (e) {}
  var deadline = new Date(root.getAttribute('data-deadline')).getTime();
  var EN = {
    n0: 'Product', n1: 'Uses', n2: 'How it works', n3: 'Results', n4: 'FAQ',
    eyebrow: 'Special effect · Car paint',
    h1: 'Turn your car into a crime scene',
    lead: 'Realistic blood splatter for your car. Built for Halloween, film and photo shoots. Washes off with water.',
    cta: 'Order now', cta2: 'See the results',
    from: '470 ml bottle · from', shipnote: 'free shipping from 2 bottles',
    t0: 'Ships the same day · Canada Post · tracking included',
    t1: 'Halloween guarantee: 100% refund if it doesn’t arrive before October 31 (orders placed before October 27)',
    t2: 'Secure checkout',
    packsEyebrow: 'Our bundles', packsTitle: 'The more you take, the less you pay',
    tag2: 'Recommended', tag3: 'Best value',
    sub1: '1 to 2 cars depending on use', sub2: '2 to 4 cars · better price per bottle', sub3: '3 to 6 cars · the lowest price per bottle',
    gift: 'Free shipping included', choose: 'Choose this bundle →',
    usesEyebrow: 'What it’s for', usesTitle: 'Three ways to scare people',
    u0t: 'Halloween', u0: 'Turn your car into the scariest thing on the street. The neighbors will talk about it.',
    u1t: 'Film and video', u1: 'Fresh-blood realism on camera for short films, music videos and creative content.',
    u2t: 'Special effects and photo', u2: 'For shoots and staged scenes that need a convincing crime scene on the bodywork.',
    howEyebrow: 'How it works', howTitle: 'Splatter. Rinse. Done.',
    s0t: 'Test', s0: 'Try a small, hidden spot on the bodywork first.',
    s1t: 'Splatter', s1: 'Apply it to build your splatters and streaks of blood.',
    s2t: 'Rinse', s2: 'Scene over? Wash it off with water and the paint goes back to normal.',
    proofEyebrow: 'The proof', proofTitle: 'On real cars',
    proofSub: 'White, gray, black: the effect varies with the car’s color, the amount and how you apply it.',
    faqEyebrow: 'Questions', faqTitle: 'Before you order',
    q0: 'Will it damage my paint?', a0: 'The formula is made for vehicles: it’s safe for clear coats, non-staining and non-corrosive, and washes off with water. As a precaution, test a small, hidden spot before the full application.',
    q1: 'How do I get it off?', a1: 'Wash it off with water, with a pressure washer if you can. The paint goes back to normal during the wash.',
    q3: 'What are the delivery times and shipping costs?', a3: 'We ship across Canada with Canada Post, the same day you order, with a tracking number included. Estimated delivery in 48 h. Shipping is free with the 2- and 3-bottle bundles. For 1 bottle it costs $4.99. Last day to order: Tuesday, October 27 at midnight.',
    q4: 'What if my order doesn’t arrive before Halloween?', a4: 'If your order, placed before Tuesday, October 27, doesn’t arrive before October 31 according to Canada Post tracking, you get a 100% refund.',
    finalTitle: 'Ready for the scariest night of the year?', finalBtn: 'Order now',
    fl0: 'Shipping', fl1: 'Returns', fl2: 'Privacy'
  };
  var UI = {
    fr: { each: ' / flacon', save: 'Économisez', closed: 'Commandes fermées pour l’Halloween',
      bar: function (c) { return 'Halloween : dernier jour de commande le mardi 27 octobre à minuit · il reste ' + c; },
      urg: function (c) { return 'Commandes ouvertes encore ' + c; },
      cd: function (d, h, m, s) { return d + ' j ' + h + ' h ' + m + ' min ' + s + ' s'; } },
    en: { each: ' / bottle', save: 'Save', closed: 'Halloween orders are closed',
      bar: function (c) { return 'Halloween: last day to order is Tuesday, October 27 at midnight · ' + c + ' left'; },
      urg: function (c) { return 'Orders still open for ' + c; },
      cd: function (d, h, m, s) { return d + 'd ' + h + 'h ' + m + 'm ' + s + 's'; } }
  };
  var PACK_EN = { 1: '1 bottle', 2: '2 bottles', 3: '3 bottles' }, PACK_FR = {};
  $$('[data-pack-title]').forEach(function (el) { PACK_FR[el.getAttribute('data-pack-title')] = el.textContent; });
  function money(c) { var v = (c / 100).toFixed(2); return lang === 'en' ? '$' + v : v.replace('.', ',') + ' $'; }
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  $$('[data-i18n]').forEach(function (el) { el.setAttribute('data-fr', el.innerHTML); });

  function prices() {
    $$('[data-money]').forEach(function (el) { el.textContent = money(+el.getAttribute('data-money')); });
    var first = $$('[data-unit]')[0], base = first ? +first.getAttribute('data-cents') : 0;
    $$('[data-unit]').forEach(function (u) {
      var q = +u.getAttribute('data-qty'), c = +u.getAttribute('data-cents'), save = base * q - c;
      u.textContent = money(Math.round(c / q)) + UI[lang].each + (save > 0 ? ' · ' + UI[lang].save + ' ' + money(save) : '');
    });
  }
  function applyLang() {
    document.documentElement.setAttribute('lang', lang);
    $$('[data-i18n]').forEach(function (el) {
      var k = el.getAttribute('data-i18n');
      el.innerHTML = (lang === 'en' && EN[k] !== undefined) ? EN[k] : el.getAttribute('data-fr');
    });
    $$('[data-lang]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-lang') === lang); });
    $$('[data-pack-title]').forEach(function (el) {
      var q = el.getAttribute('data-pack-title');
      el.textContent = lang === 'en' ? (PACK_EN[q] || el.textContent) : (PACK_FR[q] || el.textContent);
    });
    prices(); tick();
  }
  function tick() {
    var diff = Math.max(0, deadline - Date.now()), closed = diff === 0;
    var d = Math.floor(diff / 86400000), h = Math.floor(diff % 86400000 / 3600000), m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
    var c = UI[lang].cd(d, p2(h), p2(m), p2(s));
    var bar = $('[data-bar]'), urg = $('[data-urg]');
    if (bar) bar.textContent = closed ? UI[lang].closed : UI[lang].bar(c);
    if (urg) urg.textContent = closed ? UI[lang].closed : UI[lang].urg(c);
  }
  var menu = $('[data-menu]'), mbtn = $('[data-menu-btn]');
  function closeMenu() { if (!menu) return; menu.classList.remove('open'); if (mbtn) mbtn.setAttribute('aria-expanded', 'false'); }
  if (mbtn && menu) mbtn.addEventListener('click', function (e) { e.stopPropagation(); var o = menu.classList.toggle('open'); mbtn.setAttribute('aria-expanded', o ? 'true' : 'false'); });
  document.addEventListener('click', function (e) { if (menu && !menu.contains(e.target)) closeMenu(); });
  $$('a[href^="#"]').forEach(function (a) { a.addEventListener('click', function (e) {
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    closeMenu(); }); });
  $$('[data-lang]').forEach(function (b) { b.addEventListener('click', function () {
    lang = b.getAttribute('data-lang'); try { localStorage.setItem('ps-lang', lang); } catch (e) {} applyLang(); }); });
  var top = $('[data-totop]');
  if (top) {
    window.addEventListener('scroll', function () { top.classList.toggle('show', (window.pageYOffset || document.documentElement.scrollTop) > 500); }, { passive: true });
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }
  applyLang();
  setInterval(tick, 1000);
})();